<template>
    <div>
        <router-view></router-view>
    </div>   
</template>

<script>

export default {
    name: 'Common'
}
</script>

<style scoped lang="scss">
  // .mainCarousel ::v-deep {
  //   @import "~bootstrap/dist/css/bootstrap.min";
  // }
</style>
